angular.module('eatself')
.filter('stripTimezone', function() {
  return function(dateString) {
	return dateString && dateString.split('+')[0];
  };
})